export default __webpack_public_path__ + "static/media/icon-sync.66fffdbf.svg";